import { useMemo } from 'react';
import { usePermissions } from '@/hooks/usePermissions.js';
import { useAuthStore } from '@/stores/auth.js';
import {
  canEditSettingsSection,
  canViewSettingsSection,
  type SettingsSectionKey,
} from '@/lib/settings-access.js';

export function useSettingsAccess(section: SettingsSectionKey) {
  const userRole = useAuthStore((s) => s.user?.role ?? 'read_only');
  const { flags, isLoading } = usePermissions();

  return useMemo(
    () => ({
      isLoading,
      canView: canViewSettingsSection(flags, userRole, section),
      canEdit: canEditSettingsSection(flags, userRole, section),
    }),
    [flags, userRole, section, isLoading],
  );
}
